@import 'src/assets/styles/mixins';

.borderBottomNone {
  button {
    border-bottom: none;
  }
}

.dropdownContent {
  position: relative;
}

.dropdownContentMultiCount {
  display: flex;
  justify-content: space-between;
}

.close {
  position: absolute;
  right: 18px;
  top: 12px;
}

.dropdownStatusBlock {
  display: flex;
  align-items: center;
  gap: 8px;
}

.customChild {
  max-height: unset !important;
  text-align: center;
}
